//GameVerseProjectImports
import gvHomepage from "../assets/project_GameVerse/HomePage.png";
import gvLoginpage from "../assets/project_GameVerse/Login.png";
import gvSignuppage from "../assets/project_GameVerse/Signup.png";
import gvLearnorDie from "../assets/project_GameVerse/LearnorDie.png";
import gvTressurehunt from "../assets/project_GameVerse/Tressurehunt.png";
import gvMurderMystryHomePage from "../assets/project_GameVerse/MurderMystryHomePage.png";
import gvMurderMystry from "../assets/project_GameVerse/MurderMystry.png";
import gvtictactoe from "../assets/project_GameVerse/tictactoe.png";
import gvprofile from "../assets/project_GameVerse/profile.png";

//SalesSahayakProjectImports
import ssaddCustomerPage from "../assets/project_SalesSahayak/addCustomerPage.png";
import ssaddEnquiryPage from "../assets/project_SalesSahayak/addEnquiryPage.png";
import ssaddPaymentPage from "../assets/project_SalesSahayak/addPaymentPage.png";
import ssaddCustomerDetailsPage from "../assets/project_SalesSahayak/addCustomerPage.png";
import ssallCustomerDetailsPage from "../assets/project_SalesSahayak/allCustomerDetailsPage.png";
import ssallEnquiryDetailsPage from "../assets/project_SalesSahayak/allEnquiryDetailsPage.png";
import ssallOrderDetailsPage from "../assets/project_SalesSahayak/allOrderDetailsPage.png";
import ssallPaymentDetailsPage from "../assets/project_SalesSahayak/allPaymentPage.png";
import ssenquiryDetailsPage from "../assets/project_SalesSahayak/enquiryDetailsPage.png";
import ssHomePage from "../assets/project_SalesSahayak/homePage.png";
import ssloginPage from "../assets/project_SalesSahayak/loginPage.png";
import ssorderDetailsPage from "../assets/project_SalesSahayak/orderDetailsPage.png";
import ssprofilePage from "../assets/project_SalesSahayak/profilePage.png";
import sswelcomePage from "../assets/project_SalesSahayak/welcomePage.png";

//JointerXProjectImports
import jxWelcome from "../assets/project_JointerX/jxWelcome.jpg";
import jxCandidateHome from "../assets/project_JointerX/jxCandidateHome.jpg";
import jxCandidateLogin from "../assets/project_JointerX/jxCandidateLogin.jpg";
import jxCandidateSignup from "../assets/project_JointerX/jxCandidateSignup.jpg";
import jxCandidateJobs from "../assets/project_JointerX/jxCandidateJobs.jpg";
import jxCandidateApplications from "../assets/project_JointerX/jxCandidateApplications.jpg";
import jxCandidateJobDetails from "../assets/project_JointerX/jxCandidateJobDetails.jpg";
import jxCandidateProfile from "../assets/project_JointerX/jxCandidateProfile.jpg";
import jxCandidateSettings from "../assets/project_JointerX/jxCandidateSettings.jpg";

import jxChangePassword from "../assets/project_JointerX/jxChangePassword.jpg";
import jxResetPassword from "../assets/project_JointerX/jxResetPassword.jpg";

import jxEmployerHome from "../assets/project_JointerX/jxEmployerHome.jpg";
import jxEmployerJobs from "../assets/project_JointerX/jxEmployerJobs.jpg";
import jxEmployerShortlistedCandidates from "../assets/project_JointerX/jxEmployerShortlistedCandidates.jpg";
import jxEmployerSettings from "../assets/project_JointerX/jxEmployerSettings.jpg";
import jxEmployerProfile from "../assets/project_JointerX/jxEmployerProfile.jpg";
import jxEmployerCompanyProfile from "../assets/project_JointerX/jxEmployerCompanyProfile.jpg";
import jxEmployerJobDetails from "../assets/project_JointerX/jxEmployerJobDetails.jpg";
import jxEmployerManageInterviews from "../assets/project_JointerX/jxEmployerManageInterviews.jpg";
import jxEmployerApplicants from "../assets/project_JointerX/jxEmployerApplicants.jpg";
import jxEmployerPostJobs from "../assets/project_JointerX/jxEmployerPostJobs.jpg";
import jxEmployerCandidateDetails from "../assets/project_JointerX/jxEmployerCandidateDetails.jpg";
import jxEmployerLogin from "../assets/project_JointerX/jxEmployerLogin.jpg";
import jxEmployerSignup from "../assets/project_JointerX/jxEmployerSignup.jpg";

//JointerX PlayStore ScreenShots
import MobileWelcome from "../assets/project_JointerX/ScreenShotsPlayStore/MobileWelcome.png"
import MobileCandidatesJobs from "../assets/project_JointerX/ScreenShotsPlayStore/MobileCandidatesJobs.png"
import MobileJobDetails from "../assets/project_JointerX/ScreenShotsPlayStore/MobileJobDetails.png"
import MobileManageInterviewDetails from "../assets/project_JointerX/ScreenShotsPlayStore/MobileManageInterviewDetails.png"
import MobileShortlistedCandidates from "../assets/project_JointerX/ScreenShotsPlayStore/MobileShortlistedCandidates.png"
import MobileAddJobPost from "../assets/project_JointerX/ScreenShotsPlayStore/MobileAddJobPost.png"
import MobileCandidateHome from "../assets/project_JointerX/ScreenShotsPlayStore/MobileCandidateHome.png"
import MobileEmployerHome from "../assets/project_JointerX/ScreenShotsPlayStore/MobileEmployerHome.png"


const projects = [
  {
    id: 1,
    name: "JointerX",
    description: `JointerX is a streamlined mobile application that connects job seekers and
                    employers—both managed within a single platform. Built with Android Kotlin 
                    using MVVM architecture, it features a clean and intuitive UI focused on usability.
                    Employers can post jobs, manage applicants, shortlist candidates, scheduleinterviews, 
                    and update hiring status. On the candidate side, users can browse joblistings, apply with a 
                    single click, track application status, withdraw applicationsanytime, and manage their 
                    profiles including uploading a display picture. Firebasepowers real-time authentication 
                    and data sync, while Retrofit is used selectively forbackend interaction. 
                    JointerX prioritizes simplicity, speed, and clarity—bringingfocus back to what 
                    truly matters in hiring.`,
    basedon:
      "Android Kotlin, MVVM, LiveData, Firebase, FirebaseStore, Hilt, Retrofit, Cloudinary",
    status: "Live on Play Store",
    detailsLink:"/jointerx",
     hasDetails:true,
    isLive:true,
    isCompleted:false,
    isInProgress:false,
    liveLink:"https://play.google.com/store/apps/details?id=com.jointerx.app",
    images: [
      // jxWelcome,
      // jxCandidateHome,
      // jxCandidateLogin,
      // jxCandidateSignup,
      // jxCandidateJobs,
      // jxCandidateApplications,
      // jxCandidateJobDetails,
      // jxCandidateProfile,
      // jxCandidateSettings,
      // jxChangePassword,
      // jxResetPassword,
      // jxEmployerHome,
      // jxEmployerJobs,
      // jxEmployerShortlistedCandidates,
      // jxEmployerSettings,
      // jxEmployerProfile,
      // jxEmployerCompanyProfile,
      // jxEmployerJobDetails,
      // jxEmployerManageInterviews,
      // jxEmployerApplicants,
      // jxEmployerPostJobs,
      // jxEmployerCandidateDetails,
      // jxEmployerLogin,
      // jxEmployerSignup,
        
        MobileWelcome,
        MobileCandidatesJobs,
        MobileJobDetails,
        MobileManageInterviewDetails,
        MobileShortlistedCandidates,
        MobileAddJobPost,
        MobileCandidateHome,
        MobileEmployerHome      
    
    ],
  },
  {
    id: 2,
    name: "Sales Sahayak",
    description: ` The majority of small-scale companies are still storing their sales, 
        etc information about the enquiry, and pending payments in basic Excel sheets which are not that
         good looking or understandable by a different employee who will manage this data and also they are
          not managed properly because of that followup to the enquiry of customers are not done timely and 
          companies loses the orders. Here our project SalesSahayak Comes into play, it will store all enquiries 
          from customers, orders from customers, and pending payment orders. It will also store the contact 
          information of the customer/company. Thus on our website, an employee of that company can enter data 
          like new enquiries, new customers, regular orders which come without enquiry, pending payment etc. 
          However, this information will be different for every employee because every employee will be handling 
          different clients. The information on the enquiry, orders, and payments of all the employees will be visible 
          to the owner of the company with his/her special login account. 
            In this way, our website will help businesses to streamline their sales department.`,
    basedon: "Asp.net(Webforms), C#, HTML, CSS",
    status: "Project Completed",
    detailsLink:"#",
    hasDetails:false,
    isLive:false,
    isCompleted:true,
    isInProgress:false,
    images: [
      sswelcomePage,
      ssloginPage,
      ssHomePage,
      ssprofilePage,
      ssaddCustomerPage,
      ssaddEnquiryPage,
      ssaddPaymentPage,
      ssaddCustomerDetailsPage,
      ssallCustomerDetailsPage,
      ssallEnquiryDetailsPage,
      ssallOrderDetailsPage,
      ssallPaymentDetailsPage,
      ssenquiryDetailsPage,
      ssorderDetailsPage,
    ],
  },
  {
    id: 3,
    name: "GameVerse",
    description: `GameVerse is a desktop-based game platform developed using Pygame and Tkinter. 
                    It offers users a collection of fun and interactive games with a simple GUI for easy navigation. 
                    The platform allows players to choose games, track their scores or progress, and enjoy an engaging 
                    experience—all within a unified interface. Designed for casual gamers and programming enthusiasts, 
                    GameVerse also serves as a learning tool to help beginners understand Python programming through game 
                    development.`,
    basedon: "Python, Tkinter(Python Library), Pygame(Python Library)",
    status: "Project Completed",
    detailsLink:"#",
    hasDetails:false,
    isLive:false,
    isCompleted:true,
    isInProgress:false,
    images: [
      gvHomepage,
      gvLoginpage,
      gvSignuppage,
      gvLearnorDie,
      gvTressurehunt,
      gvMurderMystryHomePage,
      gvMurderMystry,
      gvtictactoe,
      gvprofile,
    ]
   
  },
  
];

export default projects;
